import CancelRequestService from 'services/http/CancelRequestService';

abstract class AbstractCancelRequestService {
  protected requestIds: string[] = [];

  public addRequestId(requestId: string) {
    this.requestIds.push(requestId);
  }

  public cancelRequests(): void {
    CancelRequestService.cancelRequests(this.requestIds);
    this.requestIds = [];
  }
}

export default AbstractCancelRequestService;
